import script from "./OrdersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrdersView.vue?vue&type=script&lang=ts&setup=true"

import "./OrdersView.vue?vue&type=style&index=0&id=285f94f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285f94f8"]])

export default __exports__